import { extractFlowPattern, extractScheduleNames } from "./callFlowUtils";
export const analyzeFlowPatterns = (interactions) => {
    const patternMap = new Map();
    const coreFlowInteractions = interactions.filter((interaction) => {
        const action = interaction.InteractionFinalAction;
        return action !== "HangUp" && action !== "Hangup" && action !== "Disconnect" && action !== "Disconnected";
    });
    coreFlowInteractions.forEach((interaction) => {
        const pattern = extractFlowPattern(interaction.CallFlow || "", interaction.InteractionFinalAction || "Unknown");
        if (!patternMap.has(pattern)) {
            patternMap.set(pattern, []);
        }
        patternMap.get(pattern).push(interaction);
    });
    const totalCoreFlowInteractions = coreFlowInteractions.length;
    return Array.from(patternMap.entries())
        .map(([pattern, patternInteractions]) => {
        const scheduleNamesMap = {};
        patternInteractions.forEach((interaction) => {
            if (interaction.CallFlow) {
                const scheduleNames = extractScheduleNames(interaction.CallFlow);
                scheduleNames.forEach((scheduleName) => {
                    if (!scheduleNamesMap[scheduleName]) {
                        scheduleNamesMap[scheduleName] = 0;
                    }
                    scheduleNamesMap[scheduleName]++;
                });
            }
        });
        return {
            pattern,
            count: patternInteractions.length,
            percentage: totalCoreFlowInteractions > 0
                ? Math.round((patternInteractions.length / totalCoreFlowInteractions) * 100)
                : 0,
            interactions: patternInteractions,
            scheduleNames: scheduleNamesMap,
        };
    })
        .sort((a, b) => b.count - a.count);
};
//# sourceMappingURL=interactionUtils.js.map